import { FetchResponse } from '../types/fetchResponse';

const abortErrorSymbol = Symbol('AbortError');
const abortErrorProperty = Symbol('AbortErrorProperty');

export function generateApiAbortError(message?: string) {
  const error = new Error(message || 'Aborted');
  (error as any)[abortErrorProperty] = abortErrorSymbol;

  return error;
}

export function isApiAbortError(error: Error) {
  return (error as any)[abortErrorProperty] === abortErrorSymbol;
}

export async function fetchAllPages<T>(
  fetchFunction: (
    page: number,
  ) => Promise<FetchResponse<{ items: T[]; metadata: { last_page?: number } }>>,
) {
  const page = 1;
  const { data: pageData } = await fetchFunction(page);

  const lastPage = pageData.metadata.last_page;

  const data = { ...pageData };

  if (lastPage) {
    await Promise.all(
      Array.from({ length: lastPage - 1 }, async (_, i) => {
        const { data: pageData } = await fetchFunction(i + 2);
        data.items.push(...pageData.items);
      }),
    );
  }

  return { data };
}
